import CustomCheckBox from "../../../UIElements/CustomCheckBox";
import CustomChip from "../../../UIElements/CustomChip";
import { Box, Card, CardActions, CardContent, Typography } from "@mui/material";
import { Fragment, useState } from "react";

type DossierToAssignCardType = {
    dossierDetail: any;
    onDossierSelect: Function;
};

export default function DossierToAssignCard({
    dossierDetail,
    onDossierSelect,
}: DossierToAssignCardType) {
    const { id, referenciel, dossierStatus, establishment } = dossierDetail;

    const dossierStatusColors = { border: "#FF900D", background: "#FFE9CF" };

    const [isSelected, setIsSelected] = useState<boolean>(false);

    const handleCheckboxChange = () => {
        setIsSelected(!isSelected);
        onDossierSelect(dossierDetail.id, !isSelected);
    };

    const card = (
        <Fragment>
            <Box
                sx={{
                    display: "flex",
                    // height: "147px",
                    //height: "16.63vh",
                    flexDirection: "column",

                    alignItems: "flex-start",
                    flexShrink: 0,
                    flex: "1 0 0",
                    gap: "2rem",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        // height: "147px",
                        //height: "16.63vh",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        flexShrink: 0,
                        alignSelf: "stretch",
                        gap: "1rem",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "2rem",
                            flex: "1 0 0",
                            width: "100%",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "1.5rem",
                                alignSelf: "stretch",
                            }}
                        >
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1.5rem",
                                    padding: 0,
                                    alignSelf: "stretch",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "1rem",

                                        alignSelf: "stretch",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "flex-start",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <CustomChip
                                            sx={{
                                                display: "flex",
                                                height: "1.5rem",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                borderRadius: "1.25rem",
                                                border: `1x solid ${dossierStatusColors.border}`,
                                                background: `${dossierStatusColors.background}`,
                                                borderColor: `${dossierStatusColors.border}`,
                                                ".MuiChip-label": {
                                                    color: "#023",
                                                    textAlign: "center",
                                                    fontFamily: "Roboto",
                                                    fontSize: "0.75rem",
                                                    fontStyle: "normal",
                                                    fontWeight: "500",
                                                    lineHeight: "normal",
                                                },
                                            }}
                                            label={dossierStatus.label}
                                        />

                                        <CustomCheckBox
                                            label={""}
                                            checked={isSelected}
                                            onChange={handleCheckboxChange}
                                        />
                                    </Box>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "0.25rem",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#005499",
                                                textAlign: "left",
                                                textEdge: "cap",
                                                fontFamily: "Roboto",
                                                fontSize: "0.875rem",
                                                fontStyle: "normal",
                                                fontWeight: "500",
                                                lineHeight: "normal",
                                                width: "100%",
                                            }}
                                        >
                                            #{id}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#023",
                                                fontFamily: "Roboto",
                                                fontSize: "1.25rem",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                lineHeight: "normal",
                                                flex: "1 0 0",
                                            }}
                                        >
                                            {establishment.companyName}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color: "#023",
                                                fontFamily: "Roboto",
                                                fontSize: "1rem",
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                            }}
                                        >
                                            Dossier de qualification pour l'
                                            {referenciel.name}
                                        </Typography>
                                    </Box>
                                </Box>
                            </CardContent>
                            <CardActions
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    cursor: "pointer",
                                    padding: 0,
                                    width: "100%",
                                }}
                            ></CardActions>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Fragment>
    );

    return (
        <Card
            variant="outlined"
            sx={{
                display: "flex",
                // height: "195px",
                padding: "1.5rem",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2rem",

                borderRadius: "1.5rem",
                background: " #FFF",

                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
                border: isSelected ? " 1px solid #0082DE" : 0,
            }}
        >
            {card}
        </Card>
    );
}
